import { BasicQueryStringUtils } from '@openid/appauth';

class SpacesBasicQueryStringUtils extends BasicQueryStringUtils {
  parse = (input, useHash) => this.parseQueryString(input.search);
}

export default SpacesBasicQueryStringUtils;
